module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-2.fb0f73c5.png";